<template>
    <div id="denfenceDiv" v-show="eleshow">
      <eleSetting ref="setting" electron="electron"></eleSetting>
      <div id="eleTool">
        <el-button type="primary" @click="addEle" size="small">新增</el-button>
        <el-button type="primary" @click="showSetting" size="small">设置规则</el-button>
      </div>
      <div v-show="contentShow">
        <div id="eleSearch">
          <el-input id="eleInput" v-model="input" placeholder="电子围栏编号" size="small"></el-input>
          <el-select v-model="value" placeholder="请选择报警类型" size="small" style="margin: 0 10px">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-button size="small" type="primary" @click="doSearch()">查询</el-button>
        </div>
          <el-table
              :data="tableData"
              border
              size="mini"
              max-height="520px"
              style="width: 100%">
              <el-table-column
              type="selection"
              width="55">
              </el-table-column>
              <el-table-column
              prop="id"
              label="序号"
              width="50">
              </el-table-column>
              <el-table-column
              prop="electron"
              label="编号">
              </el-table-column>
               <el-table-column
              prop="type"
              width="120px"
              label="报警类型">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ getWarnType(scope.row.type) }}</span>
              </template>
              </el-table-column>
              <el-table-column
              prop="uplimit"
              width="120px"
              center
              label="报警时限(秒)">
              </el-table-column>
              <el-table-column
              prop="visWarn"
              label="访客">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.visWarn==1?"报警":"不报警" }}</span>
              </template>
              </el-table-column>
              <el-table-column
              prop="conWarn"
              label="承包商">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.conWarn==1?"报警":"不报警" }}</span>
              </template>
              </el-table-column>
              <el-table-column
              fixed="right"
              label="操作"
              width="170">
              <template slot-scope="scope">
                  <el-button @click="showSetting(scope.row)" type="text" size="small">设置</el-button>
                  <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
                  <el-button @click="updateOpen(scope.row.electron)" type="text" size="small">修改</el-button>
                  <el-button @click="checkEle(scope.row)" type="text" size="small">查看</el-button>
              </template>
              </el-table-column>
          </el-table>
      </div>
      <el-dialog
        title="电子围栏编号修改"
        :visible.sync="updateVisible"
        width="30%"
        :before-close="handleClose">
        <span>电子围栏编号 ：</span><el-input v-model="electron" clearable placeholder="请输入新编号"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="updateVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateVisible = false;doUpdate()">确 定</el-button>
        </span>
      </el-dialog>

    </div>
</template>
<style scoped>
#eleTool{
    float: right;
    /* width: 200px; */
}
#denfenceDiv{
    background: white;
    position: absolute;
    width: 50%;
    height: 600px;
    top: 50%;
    z-index: 1003;
    left: 50%;
    transform: translate(-50%, -60%);
    padding: 10px;
}
#eleSearch{
  width: 500px;
  margin-bottom: 10px;
}
.el-input{
  width: 200px!important;
}

</style>
<script>
import eleSetting from "../components/eleSetting.vue"
import cesiumUtil from '../utils/cesiumUtils';
import {getElectronWarn,getElectronPoint,savaElectron,getElectronWarnList,updateElectronNo,deleteElectron} from "@/api/ele.js"
import {
  Viewer,
  Color,
  ScreenSpaceEventType,
  PolylineGlowMaterialProperty,
  Cartesian3,
  ScreenSpaceEventHandler,
  Entity,
  ImageMaterialProperty,
  CallbackProperty,
  Ion,
   Math as cesiumMath
} from 'cesium';
import CONSTANTS from "@/views/control/map/constants";
import MapUtil from '@/views/control/map/util/mapUtil';

  export default {
    components:{
      eleSetting
    },
    data() {
      return {
        options:[],
        tempEntities:[],
        allBoxEntitys:[],
        updateVisible:false,//修改可见
        electron:undefined,//选择的电子围栏Id
        oldelectron:undefined,//选择的电子围栏Id 旧
        username:"",//用户名
        password:"",//密码
        contentShow:true,
        input:undefined,
        value:undefined,
        eleshow:false,
        eleDict:{},
        eleEntity:{},
        eles:[],
        elePts:{"data":{"electron":[{"pointX":3604.62569213732,"imgH":2728.0,"lng":119.91233659785043,"pointY":662.2538975501113,"imgW":5489.0,"electron":"埋地罐区","workshopid":0,"type":1,"layer":1,"lat":31.81778586812677},{"pointX":3635.018826135105,"imgH":2728.0,"lng":119.91215986588361,"pointY":1202.9933184855233,"imgW":5489.0,"electron":"埋地罐区","workshopid":0,"type":1,"layer":1,"lat":31.8178359079043},{"pointX":4787.498485766202,"imgH":2728.0,"lng":119.91201247686155,"pointY":1206.1680876979294,"imgW":5489.0,"electron":"埋地罐区","workshopid":0,"type":1,"layer":1,"lat":31.817522896051553},{"pointX":4787.498485766202,"imgH":2728.0,"lng":119.91218456555586,"pointY":667.8781973203411,"imgW":5489.0,"electron":"埋地罐区","workshopid":0,"type":1,"layer":1,"lat":31.817464856627282},{"pointX":2822.690883190883,"imgH":2728.0,"lng":119.91221531331948,"pointY":1352.2750716332378,"imgW":5489.0,"electron":"1","workshopid":0,"type":1,"layer":1,"lat":31.818072872145724},{"pointX":2838.32905982906,"imgH":2728.0,"lng":119.91233077711784,"pointY":984.8939828080229,"imgW":5489.0,"electron":"1","workshopid":0,"type":1,"layer":1,"lat":31.818029008476902},{"pointX":3367.8721986674745,"imgH":2728.0,"lng":119.91229794598034,"pointY":877.2131546894032,"imgW":5489.0,"electron":"2","workshopid":0,"type":1,"layer":1,"lat":31.817873417672523},{"pointX":3417.741974560872,"imgH":2728.0,"lng":119.9121630767401,"pointY":1279.2691839220463,"imgW":5489.0,"electron":"2","workshopid":0,"type":1,"layer":1,"lat":31.817903208733515},{"pointX":3075.30284675954,"imgH":2728.0,"lng":119.91230642316098,"pointY":966.9281364190011,"imgW":5489.0,"electron":"2","workshopid":0,"type":1,"layer":1,"lat":31.81796263923288},{"pointX":1939.6225961538462,"imgH":2728.0,"lng":119.91263549700575,"pointY":388.77294685990336,"imgW":5489.0,"electron":"3","workshopid":0,"type":1,"layer":1,"lat":31.818209087933923},{"pointX":2652.137019230769,"imgH":2728.0,"lng":119.91257660087793,"pointY":289.9323671497585,"imgW":5489.0,"electron":"3","workshopid":0,"type":1,"layer":1,"lat":31.818004701212427},{"pointX":1933.0252403846155,"imgH":2728.0,"lng":119.9127964358078,"pointY":-112.01932367149759,"imgW":5489.0,"electron":"3","workshopid":0,"type":1,"layer":1,"lat":31.818156885365223},{"pointX":1517.391826923077,"imgH":2728.0,"lng":119.9127270422954,"pointY":270.1642512077295,"imgW":5489.0,"electron":"3","workshopid":0,"type":1,"layer":1,"lat":31.818311102015507},{"pointX":1517.391826923077,"imgH":2728.0,"lng":119.9127270422954,"pointY":270.1642512077295,"imgW":5489.0,"electron":"3","workshopid":0,"type":1,"layer":1,"lat":31.818311102015507},{"pointX":983.0060096153846,"imgH":2728.0,"lng":119.9128897101125,"pointY":-26.357487922705314,"imgW":5489.0,"electron":"3","workshopid":0,"type":1,"layer":1,"lat":31.81842442764484},{"pointX":5131.576744186046,"imgH":2728.0,"lng":119.91230547793798,"pointY":152.97196261682242,"imgW":5489.0,"electron":"南通道","workshopid":0,"type":1,"layer":1,"lat":31.817315785103972},{"pointX":5162.213023255814,"imgH":2728.0,"lng":119.91152237674541,"pointY":2590.3252336448595,"imgW":5489.0,"electron":"南通道","workshopid":0,"type":1,"layer":1,"lat":31.817570255229228},{"pointX":5448.1516279069765,"imgH":2728.0,"lng":119.91147953968634,"pointY":2610.7214953271027,"imgW":5489.0,"electron":"南通道","workshopid":0,"type":1,"layer":1,"lat":31.817494708940444},{"pointX":5432.833488372094,"imgH":2728.0,"lng":119.91226721594045,"pointY":152.97196261682242,"imgW":5489.0,"electron":"南通道","workshopid":0,"type":1,"layer":1,"lat":31.817233874717186},{"pointX":2729.3034330011074,"imgH":2728.0,"lng":119.91240115361057,"pointY":808.0712694877506,"imgW":5489.0,"electron":"甲类仓库","workshopid":0,"type":1,"layer":1,"lat":31.818039586710228},{"pointX":2716.416744186047,"imgH":2728.0,"lng":119.91259266066578,"pointY":214.1607476635514,"imgW":5489.0,"electron":"甲类仓库","workshopid":0,"type":1,"layer":1,"lat":31.817979053999323},{"pointX":4529.063255813954,"imgH":2728.0,"lng":119.91189358371611,"pointY":1680.7340823970037,"imgW":5489.0,"electron":"树脂车间","workshopid":0,"type":1,"layer":1,"lat":31.81764433205104},{"pointX":4998.819534883721,"imgH":2728.0,"lng":119.91183228774098,"pointY":1685.8426966292134,"imgW":5489.0,"electron":"树脂车间","workshopid":0,"type":1,"layer":1,"lat":31.81751715820041},{"pointX":5049.88,"imgH":2728.0,"lng":119.9116477839166,"pointY":2242.681647940075,"imgW":5489.0,"electron":"树脂车间","workshopid":0,"type":1,"layer":1,"lat":31.817563314502756},{"pointX":4804.789767441861,"imgH":2728.0,"lng":119.9116756459224,"pointY":2252.8988764044943,"imgW":5489.0,"electron":"树脂车间","workshopid":0,"type":1,"layer":1,"lat":31.81763105510225},{"pointX":4779.259534883721,"imgH":2728.0,"lng":119.9115955952926,"pointY":2513.438202247191,"imgW":5489.0,"electron":"树脂车间","workshopid":0,"type":1,"layer":1,"lat":31.817666088498594},{"pointX":4549.487441860465,"imgH":2728.0,"lng":119.91161824537417,"pointY":2533.87265917603,"imgW":5489.0,"electron":"树脂车间","workshopid":0,"type":1,"layer":1,"lat":31.817730765803883},{"pointX":3497.641860465116,"imgH":2728.0,"lng":119.91203699778778,"pointY":1641.8990654205606,"imgW":5489.0,"electron":"甲类车间","workshopid":0,"type":1,"layer":1,"lat":31.817920583738264},{"pointX":3487.429767441861,"imgH":2728.0,"lng":119.91175627941826,"pointY":2524.03738317757,"imgW":5489.0,"electron":"甲类车间","workshopid":0,"type":1,"layer":1,"lat":31.81801847416743},{"pointX":5090.728372093023,"imgH":2728.0,"lng":119.91153308601018,"pointY":2585.2261682242993,"imgW":5489.0,"electron":"甲类车间","workshopid":0,"type":1,"layer":1,"lat":31.817589141801424},{"pointX":5080.516279069768,"imgH":2728.0,"lng":119.9118343300273,"pointY":1646.9981308411216,"imgW":5489.0,"electron":"甲类车间","workshopid":0,"type":1,"layer":1,"lat":31.81749075692031},{"pointX":1613.5106976744185,"imgH":2728.0,"lng":119.91198613127855,"pointY":2549.532710280374,"imgW":5489.0,"electron":"丙类仓库","workshopid":0,"type":1,"layer":1,"lat":31.818530733493784},{"pointX":2741.946976744186,"imgH":2728.0,"lng":119.9118346601817,"pointY":2575.0280373831774,"imgW":5489.0,"electron":"丙类仓库","workshopid":0,"type":1,"layer":1,"lat":31.818226665574944},{"pointX":2721.5227906976743,"imgH":2728.0,"lng":119.91218936591187,"pointY":1473.6299065420562,"imgW":5489.0,"electron":"丙类仓库","workshopid":0,"type":1,"layer":1,"lat":31.818113464011777},{"pointX":1639.0409302325584,"imgH":2728.0,"lng":119.91232032911238,"pointY":1494.026168224299,"imgW":5489.0,"electron":"丙类仓库","workshopid":0,"type":1,"layer":1,"lat":31.818409985242816}]},"msginfo":"成功！","status":0},
        tableData: [],
        multipleSelection:[],
        polygonDrawing:null,
        positionDrawing:[],
      }
    },
    methods: {
      doUpdate(){
        let _this=this
        updateElectronNo({
          "updElectron":this.electron,
          "oldElectron":this.oldelectron
        }).then(res=>{
          _this.$message.success("修改成功")
          _this.doSearch()
        })
      },
      // 打开修改
      updateOpen(id){
        this.electron=id
        this.oldelectron=id
        this.updateVisible=true
        
      },
      // 获取报警类型
      getWarnType(type){
        switch(type){
          case 1:
            return '闯入围栏报警'
            break;
          case 2:
            return '离岗报警'
            break;
          case 3:
            return '违规停车'
            break;
          case 4:
            return '超时滞留'
            break;
        }
      },
      // 查看电子围栏
      checkEle(row){
        if(this.eleEntity[row.electron]){
          this.D3Config.Viewer.flyTo(this.eleEntity[row.electron])
        }
      },
      //搜索
      doSearch(){

        let _this=this
        let username=this.username=this.D3Config.username
        let password=this.password=this.D3Config.password
        getElectronWarnList(username,password).then((res)=>{
          _this.tableData=res.data.data;
        })
      },
      /**
       * 创建鼠标提示信息框
       */
      createTooltip(){
          // 提示框
          let tooltip = document.createElement('div');
          this.tooltip=tooltip;
          document.body.appendChild(tooltip);
          tooltip.width = '300';
          tooltip.height = '300';
          tooltip.style.display = 'none';
          tooltip.style.position = 'absolute';
          tooltip.innerHTML = `点击开始`;
      },
      /**
         * 画多边形
         */
        drawPolygon(positions) {
            let _this=this
            if (positions.length < 2) return;
            let coors=[];
            let uniCode=_this.getUniCode();
            let params=[];
            for(let i=0;i<positions.length;i++){
                let lonlat=cesiumUtil.Cartesian3_to_WGS84(positions[i]);
                coors.push(lonlat[0]);
                coors.push(lonlat[1]);
                params.push({
                  "electron": uniCode,
                  "longitude":lonlat[0],
                  "latitude":lonlat[1]
                });
            }
          savaElectron(params).then(res=>{
              _this.doSearch();
              _this.generateAllBox();
              _this.D3Config.Viewer.entities.removeAll();
          })

        var polygonGeometry=new Entity({
                name:'',
                polygon: {
                    hierarchy: Cartesian3.fromDegreesArray(coors),
                    extrudedHeight: 0.0,
                }
            })
            return polygonGeometry;
        },
      /**
         * 画线
         */
        drawPolyline(positions, config) {
        if (positions.length < 1) return;
        var config = config ? config : {};
        var polylineGeometry = this.D3Config.Viewer.entities.add({
            name: '线几何对象',
            polyline: {
            positions: positions,
            width: config.width ? config.width : 5.0,
            material: new PolylineGlowMaterialProperty({
                color: config.color
                ? new Color.fromCssColorString(config.color)
                : Color.GOLD
            }),
            depthFailMaterial: new PolylineGlowMaterialProperty({
                color: config.color
                ? new Color.fromCssColorString(config.color)
                : Color.GOLD
            })
            }
        });
        return polylineGeometry;
        },
      /**
         * 画点
         */
        drawPoint(position, config) {
            var config = config ? config : {};
            var pointGeometry = this.D3Config.Viewer.entities.add({
                name: '点几何对象',
                position: position,
                point: {
                color: Color.SKYBLUE,
                pixelSize: 2,
                outlineColor: Color.YELLOW,
                outlineWidth: 1,
                disableDepthTestDistance: Number.POSITIVE_INFINITY
                }
            });
            return pointGeometry;
        },
      //开始绘制
      drawEle(){
        let that=this;
        let viewer=this.D3Config.Viewer
        this.createTooltip();
        var tempPoints = [],
            tempEntities = this.tempEntities;
        let handler = new ScreenSpaceEventHandler(viewer.scene.canvas);
        that.tooltip.style.display = 'block';
        //鼠标移动事件
        handler.setInputAction(function(movement) {
            that.tooltip.style.left = movement.endPosition.x + 10 + 'px';
            that.tooltip.style.top = movement.endPosition.y + 20 + 'px';
        }, ScreenSpaceEventType.MOUSE_MOVE);
        //左键点击操作
        handler.setInputAction(function(click) {
            //调用获取位置信息的接口
            let position =viewer.camera.pickEllipsoid(
              click.position,
              viewer.scene.globe.ellipsoid
            );
            tempPoints.push(position);

            let tempLength = tempPoints.length;
            //调用绘制点的接口
            let point = that.drawPoint(position);

            tempEntities.push(point);
            if (tempLength > 1) {
                let pointline = that.drawPolyline([
                    tempPoints[tempPoints.length - 2],
                    tempPoints[tempPoints.length - 1]
                ]);
                tempEntities.push(pointline);
            } else {
                that.tooltip.innerHTML = '请绘制下一个点，右键结束';
            }
            return;
        }, ScreenSpaceEventType.LEFT_CLICK);
        //右键点击操作
        handler.setInputAction(function(click) {
            window.oncontextmenu=function(e){
                e.preventDefault();
            }
            let mouse_pos=click.position;
            let cartesian = viewer.camera.pickEllipsoid(
                click.position,
                viewer.scene.globe.ellipsoid
            );
            if (cartesian) {
            let tempLength = tempPoints.length;
            if (tempLength < 3) {
                alert('请选择3个以上的点再执行闭合操作命令');
            } else {
                //闭合最后一条线
                // debugger
                let pointline = that.drawPolyline([
                    tempPoints[tempPoints.length - 1],
                    tempPoints[0]
                ]);
                tempEntities.push(pointline);
                that.createBox(tempPoints,mouse_pos);
                tempEntities.push(tempPoints);
                handler.destroy(); //关闭事件句柄
                handler = null; //销毁事件对象
                that.tooltip.style.display = 'none'; //移除鼠标提示
            }
            }
        }, ScreenSpaceEventType.RIGHT_CLICK);
      },
      // 生成围栏唯一值
      getUniCode() {
        // 0x   表示16进制数据的开头
        //可以直接return (((1+Math.random())*0x10000)|0).toString(16)；    
        
        //也可用如下，随机数*时间戳，再转化为16进制
        //Number.toString(16)    表示将其转换为16进制
        // Number | 0 表示取整数部分

        let stamp = new Date().getTime();
        return (((1+Math.random())*stamp)|0).toString(16);
      },
      /**
         * 生成罩子
         * @param {*} pos 
         * @param {*} mousePos 
         */
        createBox(pos,mousePos){
            let that=this;
            this.polygonDrawing=this.drawPolygon(pos);
            // debugger
            this.positionDrawing=pos;
            
            // //弹出新增窗口
            // this.change_isAdd({info:1});
            // this.change_addBoxWindow_Visual({visual:true})

        },
      //新增
      addEle(){
        this.eleshow=false;
        this.drawEle()
      },
      toggle(){
        console.log(this.eleshow, '======14545======')
        this.eleshow=!this.eleshow
        if(this.eleshow){
          this.generateAllBox()
          this.doSearch()
        }
      },
      //显示设置
      showSetting(id){
        this.$refs.setting.toggle(id)
      },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
      handleClick(row) {
        let _this=this
        deleteElectron(row.electron).then(res=>{
          _this.$message.success("删除成功")
          _this.doSearch()
          _this.generateAllBox();
        })
      },
      //开关地图上的
      showBoxDraw() {
        this.V = this.D3Config.Viewer;
        let arr=this.allBoxEntitys;
        arr.forEach((entity)=>{
            //this.entitiesShow=!this.entitiesShow;
            entity.show=!entity.show;
        })
      },
      generateAllBox(){
        let username=this.username=this.D3Config.username
        let password=this.password=this.D3Config.password
        let _this=this
        let self = this;
        self.eleFenceLayer=MapUtil.getLayerByName(CONSTANTS.LAYER.ELEFENCE);
        getElectronPoint(username,password).then(res=>{
          if(res.data){
            let elePts=res.data.data.electron
            let eleDict=_this.eleDict={}
            elePts.forEach((_box,index)=>{
              let coors=[]
              if(eleDict[_box.electron]){
                coors=eleDict[_box.electron]
              }

              coors.push(Number(_box.lng));
              coors.push(Number(_box.lat));
              eleDict[_box.electron]=coors

            })
            self.eleEntity={}
            for(let name in eleDict){
              let coors=eleDict[name]
              let options={};
              options={
                name:name,
                height:Number(20)
              }

              let boxEntity=cesiumUtil.createElePolygon(coors,options);
              self.eleEntity[name]=boxEntity
              self.allBoxEntitys.push(boxEntity);
              self.eleFenceLayer.dataSource.entities.add(boxEntity);
            }
          }
        })
        
       
        },
        handleClose(done) {
          this.updateVisible=false;
        }
    },
    mounted(){
        this.generateAllBox()
        this.doSearch()
    }
    
  }
</script>
<style>
.wrapper_boxManager{
    position:absolute;
    left:0;
    bottom:0;
    padding:15px;
    box-sizing: border-box;
    background: #FFF;
    max-height:60vh;
    overflow-y:scroll;
    left: 0;
    bottom: 0;
    border: 1px solid #EBEEF5;
}
</style>